// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_ibZ","question":"styles_question__1To8W","inputVisibleButton":"styles_inputVisibleButton__2xmm0","note":"styles_note__39o6U"};